module.exports = __webpack_public_path__ + "play.svg?0df5d6f21e106126f776f716868ae01d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play.svg
// module id = 103
// module chunks = 0